import { Box, Flex, Text } from 'rebass/styled-components';
import styled from 'styled-components';

import Media from '../../../utils/Media';
import { Heading } from '../../components';

export const StyledModuleHeading = styled(Heading)`
  color: ${({ theme }) => theme.text.heading.color ?? theme.colors.text};
  font-weight: ${props => props.theme.productListing.titleFontWeight || 'normal'};
  word-break: break-word;
  margin-top: 0px;
  line-height: 1.2;

  ${Media({
    marginBottom: ['1rem', null, null, '1.5rem'],
  })}
`;

export const StyledModuleDescription = styled(Text)`
  color: ${props => props.theme.colors.text};
  line-height: 1.875rem;
  font-size: 1.25rem;

  ${Media({
    marginBottom: ['3.0625rem', null, null, '3.25rem'],
  })}
`;

export const StyledHeadingAndDescriptionContainer = styled(Flex)`
  width: 100%;
  justify-content: center;
`;

export const StyledHeadingAndDescriptionWrapper = styled(Box)`
  max-width: 605px;
`;

export const StyledLoadMoreWrapper = styled(Box)`
  align-self: flex-start;

  ${Media({
    marginTop: ['2.5rem', null, null, '3.5rem'],
  })}
`;
